/** Lightweight HTML stripper safe for client components. */
const NAMED_ENTITIES: Record<string, string> = {
  amp: "&",
  lt: "<",
  gt: ">",
  quot: '"',
  apos: "'",
  nbsp: " ",
}

function decodeHtmlEntities(value: string): string {
  return value.replace(/&(#x?[\da-f]+|\w+);/gi, (entity, body: string) => {
    const lower = body.toLowerCase()
    if (lower in NAMED_ENTITIES) return NAMED_ENTITIES[lower]
    if (lower.startsWith("#x")) {
      const code = Number.parseInt(lower.slice(2), 16)
      return Number.isFinite(code) ? String.fromCodePoint(code) : entity
    }
    if (lower.startsWith("#")) {
      const code = Number.parseInt(lower.slice(1), 10)
      return Number.isFinite(code) ? String.fromCodePoint(code) : entity
    }
    return entity
  })
}

export function stripHtml(html: string): string {
  if (!html) return ""
  const withoutTags = html.replace(/<[^>]*>/g, " ")
  return decodeHtmlEntities(withoutTags).replace(/\s+/g, " ").trim()
}
